module.exports = [{
      plugin: require('/Users/jaimin/Desktop/Projects/fairfest-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
